export enum EventCategory {
    ACTION_TRACKING = 'Action Tracking',
    USER_ENGAGEMENT = 'User Engagement',
  }
